<template>
    <div class="pages aurora-page aurora-account account-dashboard" :class="classObj">
        <div class="user_info">
            <div class="user_box" @click="toMyProfile">
                <AuroraArtIcon class="account-avatar" name="account" />
                <div class="account-identity"><span>{{ $t('person.PersonalCenter') }}</span><strong class="phone">{{ userPhone }}</strong><button type="button" @click.stop="copyText(userInfo.id)">ID: {{ userInfo.id }} <AuroraIcon name="copy" /></button></div>
                <span class="account-level">VIP {{ userInfo.levelDetailVo && userInfo.levelDetailVo.memberLevelCode || 0 }}</span>
                <AuroraIcon class="account-profile-arrow" name="chevron" />
            </div>
            <div class="money_box">
                <div class="header"><AuroraArtIcon name="coins" /><span>{{ $t("person.AccountTotal") }}</span></div>
                <div class="money_wrap">
                    <div>
                        <div class="money"><small>{{ CurrencyType }}</small>{{ formatAmount(allBalance, 2) }}</div>
                        <div> {{ $t('depositWithdraw.TotalBalance') }} </div>
                    </div>
                    <div>
                        <div class="money"><small>{{ CurrencyType }}</small>{{ formatAmount(useBalance, 2) }}</div>
                        <div> {{ $t('depositWithdraw.WithdrawableAmount') }} </div>
                    </div>
                </div>
                <div class="func_btns">
                    <button type="button" @click="toDeposit"><AuroraIcon name="wallet" />{{ $t("deposit.Deposit") }}</button>
                    <button type="button" @click="toWithdraw">{{ $t("Withdraw.Withdraw") }}<AuroraIcon name="chevron" /></button>
                </div>
            </div>
            <div v-if="!classObj.mobile" class="contaItem" @click.stop="toShare">
                <div class="contaTitleLine">
                    <AuroraArtIcon name="users" /><span>{{ $t("share.PromotedAccount") }}</span><AuroraIcon name="chevron" />
                </div>
                <div class="spreadLine">
                    <div class="spreadList">
                        <div v-if="invitationPageRewardState === 'enable'" class="spreadAmount">{{ formatCurrency(shareData.allGrandTotalDirectFirstAmt || 0) }}</div>
                        <div v-else>{{ CurrencyType }}0</div>
                        <div class="spreadName">{{ $t("share.TotalPrize") }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="spreadList">
                        <div v-if="invitationPageRewardState === 'enable'" class="spreadAmount">{{ formatCurrency(shareData.allUnDistributionFirstAmt || 0) }}</div>
                        <div v-else>{{ CurrencyType }}0</div>
                        <div class="spreadName">
                            {{ $t("share.BonusPendingSettlement") }}
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="spreadList">
                        <div v-if="invitationPageRewardState === 'enable'" class="spreadAmount">{{ formatCurrency(shareData.allDistributionFirstAmt || 0) }}</div>
                        <div v-else>{{ CurrencyType }}0</div>
                        <div class="spreadName">{{ $t("share.BonusesAlreadySettled") }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="menus lobby-account-menus">
            <section class="account-actions">
            <h2 class="lobby-account-heading">{{ $t('person.PersonalCenter') }}</h2>
            <div class="account-actions-grid">
            <div class="menus-item" @click="toMyProfile"><AuroraArtIcon name="account" /><span class="text">{{ $t('MyProfile.Profile') }}</span></div>
            <div class="menus-item" @click.stop="$refs.RedemptionRecordPopup.open()">
                <AuroraArtIcon name="ticket" />
                <span class="text">{{ $t("RedemptionCode.RedemptionRecord") }}</span>
            </div>
            <div v-if="invitationPageRewardState === 'enable'" class="menus-item" @click.stop="toTransaction">
                <AuroraArtIcon name="coins" />
                <span class="text">{{ $t("person.Transaction") }}</span>
            </div>
            <div class="menus-item" @click.stop="toBetHistory">
                <AuroraArtIcon name="clock" />
                <span class="text">{{ $t("person.History") }}</span>
            </div>
            <div class="menus-item" @click="toSetting">
                <AuroraArtIcon name="shield" />
                <span class="text">{{ $t("person.AccountSettings") }}</span>
            </div>
            <div class="menus-item" @click="$refs.RedemptionCodePopup.open()"><AuroraArtIcon name="ticket" /><span class="text">{{ $t('RedemptionCode.RedemptionCode') }}</span></div>
            </div>
            </section>
            <section class="account-support">
            <h2 class="lobby-account-heading">{{ $t('person.LiveChat') }} · {{ $t('socialMedia.socialMedia') }}</h2>
            <div class="menus-item" @click="$refs.lang.onShowLangPopup()"><AuroraArtIcon name="chat" />
                <span class="text"> {{ langType }}</span>
                <div class="language_box">
                    <language ref="lang" :show="true" :showIcon="false"></language>
                </div>
            </div>
            <div class="menus-item" @click="toNotification">
                <AuroraArtIcon name="envelope" /><span class="text">{{ $t("person.Notification") }}</span>
            </div>
            <div class="menus-item" @click="onNavTo({ url: sysConfig.telegram, type: 'href' })"><AuroraArtIcon name="headset" /><span class="text">{{ $t('person.LiveChat') }} 24/7</span></div>
            <div class="menus-item" @click="openCommunity"><AuroraArtIcon name="users" /><span class="text">{{ $t('socialMedia.socialMedia') }}</span></div>
            <div class="menus-item" @click="onShowDownAppPopup">
                <AuroraArtIcon name="gift" />
                <span class="text">{{ $t("person.Install") }}</span>
            </div>
            </section>
        </div>
        <button type="button" class="logout" @click="handleLogout"><AuroraIcon name="logout" />{{ $t("logout.SignOut") }}</button>
        <loginPopup @loginSucc="init"></loginPopup>
        <logoutPopup ref="logoutPopup" ></logoutPopup>
        <notification ref="notification"></notification>
        <!-- <BonusTransferPopup ref="BonusTransferPopup" @confirm="init"></BonusTransferPopup> -->
        <RedemptionRecordPopup ref="RedemptionRecordPopup"></RedemptionRecordPopup>
        <RedemptionCodePopup ref="RedemptionCodePopup"></RedemptionCodePopup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Toast } from 'vant'
import handleCopy from '@/utils/copy.js'
import logoutPopup from '@/components/logoutPopup'
import notification from '@/components/notification'
import RedemptionRecordPopup from '@/components/RedemptionCodePopup/modules/RedemptionRecordPopup.vue'
// import BonusTransferPopup from '@/components/BonusTransferPopup'
import language from '@/components/language'
import AuroraArtIcon from '@/components/auroraIcon/artIcon.vue'
import AuroraIcon from '@/components/auroraIcon'
import RedemptionCodePopup from '@/components/RedemptionCodePopup'
import {
    getListLevel,
    getUserInfo
} from '@/api/user'
import { getShareinfo } from '@/api/share'
import {
    domainName
} from '@/common/http/index.js'
export default {
    name: 'Person',
    components: { logoutPopup, notification, language, RedemptionRecordPopup, AuroraArtIcon, AuroraIcon, RedemptionCodePopup },
    computed: {
        // userMoney() {
        //     // const userInfo = this.$store.getters.userInfo
        //     const info = {
        //         balanceAmtAccount: this.allBalance
        //         // bonusAmtAccount: userInfo.balanceAmtAccount ? userInfo.bonusAmtAccount.useBalance.toFixed(2) : '0.0'
        //     }
        //     return info
        // },
        useBalance() {
            const D = this.userInfo
            let balance = 0
            if (this.rate > 0 || (D && !D.orderWater && D.turnoverLimit)) {
                balance = 0
            } else if (D && D.memberDamaliangVoList && D.memberDamaliangVoList.length && D.memberDamaliangVoList.some(x => (x.turnoverLimit || 0) - (x.orderWater || 0) > 0)) {
                balance = 0
            } else {
                balance = this.userInfo.balanceAmtAccount ? this.userInfo.balanceAmtAccount.useBalance : 0
            }
            return balance
        },
        isLogin() {
            return !!this.$store.getters.token
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        // userMoney() {
        //     // const userInfo = this.$store.getters.userInfo
        //     const info = {
        //         balanceAmtAccount: this.allBalance
        //         // bonusAmtAccount: userInfo.balanceAmtAccount ? userInfo.bonusAmtAccount.useBalance.toFixed(2) : '0.0'
        //     }
        //     return info
        // },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        langType() {
            return this.langObj[this.$store.getters.language].name || 'English'
        },
        invitationPageRewardState() {
            return this.$store.getters.userInfo && this.$store.getters.userInfo.invitationPageRewardState
        }
    },
    data() {
        return {
            domainName: '',
            vipList: [],
            userInfo: {
                levelDetailVo: {
                    memberLevelIcon: '',
                    currentAmtRecharge: 0,
                    currentAmtOrder: 0,
                    memberLevelCode: 0
                }
            },
            rate: 0,
            orderWater: 0,
            nextVipItem: {},
            shareData: {}
        }
    },
    created() {
        this.domainName = domainName
    },
    activated() {
        const that = this
        if (!that.classObj.mobile) that.getShareInfo(true)
        that.getUserInfo().then(() => {
            that.getListLevel(true)
        })
    },
    methods: {
        openCommunity() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/JoinChannel' })
        },
        init() {
            const that = this
            if (!that.classObj.mobile) that.getShareInfo(true)
            that.getUserInfo().then(() => {
                that.getListLevel(true)
            })
        },
        getUserInfo() {
            return new Promise((resolve, reject) => {
                getUserInfo().then((res) => {
                    const {
                        result,
                        code
                    } = res
                    if (code === 0) {
                        const D1 = result
                        this.userInfo = result
                        this.userInfo.levelDetailVo.currentAmtRecharge = result.levelDetailVo.currentAmtRecharge
                        this.userInfo.levelDetailVo.currentAmtOrder = result.levelDetailVo.currentAmtOrder
                        this.userInfo.levelDetailVo.memberLevelCode = result.levelDetailVo.memberLevelCode
                        const rate = ((D1.turnoverLimit || 0) - (D1.orderWater || 0)).toFixed(2)
                        this.rate = rate > 0 ? rate : 0
                        this.orderWater = D1.orderWater
                        resolve(result)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
        getListLevel(isNoLoading) {
            const that = this
            getListLevel({}, isNoLoading).then((res) => {
                that.vipList = res.result
            }).then(() => {
                this.handleVipData()
            })
        },
        getShareInfo(isNoLoading) {
            getShareinfo({}, isNoLoading).then((res) => {
                if (res?.code) return
                const D = res?.result
                this.shareData = D
            })
        },
        handleVipData() {
            const that = this
            if (that.vipList.length && that.userInfo) {
                const nextLevel = that.userInfo.levelDetailVo.memberLevelCode + 1
                that.nextVipItem = that.vipList[nextLevel] || that.vipList[that.vipList.length - 1]
                that.userInfo.rechargeProgress = (that.userInfo.levelDetailVo.currentAmtRecharge / that.nextVipItem.amtRecharge) * 100
                that.userInfo.betProgress = (that.userInfo.levelDetailVo.currentAmtOrder / that.nextVipItem.amtOrder) * 100
                if (that.userInfo.rechargeProgress > 100) {
                    that.userInfo.rechargeProgress = 100
                }
                if (that.userInfo.betProgress > 100) {
                    that.userInfo.betProgress = 100
                }
                if (that.userInfo.levelDetailVo.currentAmtRecharge === 0) {
                    that.userInfo.rechargeProgress = 0
                }
                if (that.userInfo.levelDetailVo.currentAmtOrder === 0) {
                    that.userInfo.betProgress = 0
                }
                that.userInfo.rechargeDistance = that.nextVipItem.amtRecharge - that.userInfo.levelDetailVo.currentAmtRecharge
                that.userInfo.betDistance = that.nextVipItem.amtOrder - that.userInfo.levelDetailVo.currentAmtOrder
                // console.log(that.userInfo.levelDetailVo.currentAmtRecharge, that.userInfo.levelDetailVo.currentAmtOrder)
                // console.log(that.userInfo.rechargeProgress, that.userInfo.betProgress)
            }
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        copyText(content) {
            handleCopy(
                {
                    content,
                    success: (msg) => {
                        Toast(msg)
                    },
                    error: (msg) => {
                        Toast(msg)
                    }
                },
                this
            )
        },
        handleLogout() {
            this.$refs.logoutPopup.open()
        },
        toLogin(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        },
        toDeposit() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            if (this.$route.path.indexOf('/wallet?type=deposit') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toWithdraw() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            if (this.$route.path.indexOf('/wallet?type=Withdraw') !== -1) {
                return
            }
            const params = { type: 'Withdraw' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toMyProfile() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.$store.dispatch('user/setIsShowMyProfilePopup', true)
        },
        toBetHistory() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.$store.dispatch('user/setIsShowBetHistoryPopup', true)
        },
        toTransaction() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.$store.dispatch('user/setIsShowTransactionPopup', true)
        },
        toVIP() {
            if (this.$route.path.indexOf('/vip') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavToByIsLogin({ url: 'vip' })
        },
        toSetting() {
            if (this.$route.path.indexOf('/setting') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/setting' })
        },
        onShowDownAppPopup() {
            this.$store.dispatch('user/setIsShowDownAppPopup', true)
        },
        toShare() {
            if (this.$route.path.indexOf('/affiliate') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/affiliate' })
        },
        toNotification() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/notification' })
        }
    },
    watch: {
        classObj(newVal) {
            if (!newVal.mobile) {
                this.onPageRefresh()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.pages {
    width: 100%;
    height: 100%;
    background:
        var(--aurora-soft-gradient);
    padding: .2rem .3rem .3rem;
    text-align: left;

    &.mobile{
        background:
            var(--aurora-soft-gradient) !important;

        .contaItem{
            display: none;
        }

        .money_box{
            padding: 0 !important;
            background: transparent !important;
            border: 0 !important;
            box-shadow: none !important;
            .header{
                display: none !important;
            }
            .money_wrap{
                display: none;
            }

            .func_btns{
                margin: 0 !important;
                & > div{
                    border-radius: .15rem;
                    text-align: center;
                    border-color: var(--aurora-line) !important;
                    height: 1.2rem;
                    background-image: none !important;
                    box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .16rem var(--aurora-shadow-color) !important;
                }
                & > div:first-child{
                    background:
                        var(--aurora-soft-gradient) !important;
                    color: var(--aurora-ink) !important;
                }
                & > div:last-child{
                    background:
                        var(--aurora-soft-gradient) !important;
                    color: var(--aurora-ink) !important;
                }
            }
        }
    }

    .user_info {
        position: relative;

        .user_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            margin-bottom: .2rem;
            padding: .16rem .22rem;
            border: 1px solid var(--aurora-line) !important;
            border-radius: .24rem;
            background:
                var(--aurora-soft-gradient) !important;
            box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .18rem var(--aurora-shadow-color) !important;

            .icon_logout {
                width: .98rem;
                height: .58rem;
                background: var(--aurora-soft-gradient);
                border: 1px solid var(--aurora-line);
                box-shadow: inset 0 1px 0 var(--aurora-shadow-color);
                border-radius: .32rem;
                position: relative;
                right: auto;
                top: auto;
                transform: none;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                flex: none;

                &>img {
                    height: .34rem;
                    width: .34rem;
                    vertical-align: middle;
                    filter: brightness(1.2) sepia(.18);
                }
            }

            >img {
                width: 1.2rem;
                height: 1.2rem;
                border-radius: 50%;
                border: .04rem solid var(--aurora-line);
                box-shadow: 0 0 0 .02rem var(--aurora-shadow-color);
                margin-right: .2rem;
            }

            >div {
                flex: 1;
                min-width: 0;
                padding-right: .16rem;
                display: flex;
                flex-direction: column;
                justify-content: center;

                >div {
                    &:first-child {
                        height: .34rem;
                        line-height: .34rem;
                        color: var(--aurora-ink);
                        font-size: .32rem;
                        margin-bottom: .12rem;
                        font-weight: 700;
                        text-shadow: 0 1px 2px var(--aurora-shadow-color);
                    }

                    &:last-child {
                        height: .3rem;
                        line-height: .3rem;
                        color: var(--aurora-accent);
                        font-size: .24rem;
                        display: flex;
                        align-items: center;
                        gap: .06rem;

                        i {
                            cursor: pointer;
                            color: var(--aurora-accent);
                        }
                    }
                }
            }
        }

        .vip_box {
            display: flex;
            align-items: center;
            background: var(--aurora-soft-gradient);
            border: 1px solid var(--aurora-line);
            border-radius: 10px;
            margin-bottom: 12px;
            cursor: pointer;
            overflow: hidden;
            position: relative;
            padding: 28px 20px 20px;
            column-gap: .18rem;

            .next-vip {
                position: absolute;
                top: 0;
                right: 0;
                background: var(--aurora-soft-gradient);
                border-radius: 0 .16rem 0 0;
                font-size: .2rem;
                padding: .02rem .2rem .04rem .6rem;
                color: var(--aurora-ink);
            }

            .vip_img {
                width: 1.46rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                flex: none;

                img {
                    width: 1.16rem;
                    height: .9rem;
                    vertical-align: middle;
                    object-fit: contain;
                    margin-bottom: .06rem;
                }

                .vip_level {
                    text-align: center;
                    font-size: .29rem;
                    font-weight: 800;
                    color: var(--aurora-accent);
                    font-style: italic;
                    line-height: 1;
                }
            }

            .vip_info {
                flex: 1;
                display: flex;
                align-items: flex-start;
                margin: 0;
                padding-top: .02rem;

                .vip_progress {
                    flex: 1;
                    padding-right: .04rem;

                    &:last-child {
                        color: $font-sub-color;
                        font-size: .2rem;

                        .rate {
                            font-size: .26rem;
                            color: var(--aurora-ink);
                            margin: .02rem 0 .08rem;
                            line-height: 1.15;

                            &>span {
                                color: var(--aurora-accent);
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
        }

        .func_btns {
            margin: .3rem .4rem .32rem;
            display: flex;
            justify-content: space-between;
            gap: .16rem;

            >div {
                height: .74rem;
                width: calc(50% - .08rem);
                display: flex;
                align-items: center;
                justify-content: center;
                color: var(--aurora-ink);
                font-size: .28rem;
                border-radius: .18rem;
                font-weight: bold;
                cursor: pointer;
                background: var(--aurora-soft-gradient);
                border: 1px solid var(--aurora-line);
                box-shadow: inset 0 1px 0 var(--aurora-shadow-color);

                &:first-child {
                    background: var(--aurora-soft-gradient);
                    color: var(--aurora-ink);
                    border-color: var(--aurora-line);
                    box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .06rem .14rem var(--aurora-shadow-color);
                }
            }
        }

        .money_box {
            width: 100%;
            background: var(--aurora-soft-gradient);
            border: 1px solid var(--aurora-line);
            border-radius: .2rem;
            overflow: hidden;
            margin-bottom: .2rem;

            .header {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                height: .88rem;
                font-size: .25rem;
                color: var(--aurora-ink);
                padding-left: .4rem;
            }

            .money_wrap {
                text-align: center;
                padding-top: .08rem;
                display: flex;
                align-items: center;
                justify-content: center;

                &>div{
                    width: 50%;
                }
                &>div>div:first-child {
                    color: var(--aurora-ink);
                    font-size: .34rem;
                    line-height: 1.12;
                    font-weight: 700;
                    letter-spacing: .01rem;
                }

                &>div>div:last-child {
                    color: var(--aurora-accent);
                    font-size: .22rem;
                    margin-top: .07rem;
                }
            }
        }

        .contaItem {
            width: 100%;
            background: var(--aurora-soft-gradient);
            border: .01rem solid var(--aurora-line);
            border-radius: .2rem;
            padding-bottom: .2rem;

            .contaTitleLine {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                height: .88rem;
                font-size: .25rem;
                color: var(--aurora-ink);
                padding-left: .4rem;
                cursor: pointer;
                position: relative;

                &:after {
                    content: '';
                    width: .15rem;
                    height: .15rem;
                    border-top: .01rem solid var(--aurora-line);
                    border-right: .01rem solid var(--aurora-line);
                    position: absolute;
                    right: .4rem;
                    top: 50%;
                    transform: rotate(45deg) translateY(-50%);
                }
            }

            .spreadLine {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .spreadList {
                    text-align: center;
                    flex: 0 1 100%;
                    width: 33.3%;
                    color: var(--aurora-ink);
                    font-size: .28rem;
                }

                .spreadName {
                    font-size: .24rem;
                    line-height: normal;
                    height: .5rem;
                    line-height: .25rem;
                    display: flex;
                    justify-content: center;
                    color: var(--aurora-accent);
                    white-space: pre-wrap;
                    text-align: center;
                }
            }

            .line {
                width: 1px;
                height: .7rem;
                background: var(--aurora-surface);
            }
        }
    }

    .menus {
        width: 100%;
        margin: .2rem 0;
        padding: .2rem;
        border-radius: .2rem;
        color: var(--aurora-muted);
        font-size: .28rem;
        background: var(--aurora-soft-gradient);
        border: 1px solid var(--aurora-line);

        .menus-item {
            // padding: 0 .42rem;
            height: .88rem;
            line-height: .88rem;
            text-align: left;
            color: var(--aurora-ink);
            position: relative;
            border-bottom: 1px solid var(--aurora-line);
            cursor: pointer;

            &:last-child {
                border-bottom: 0;
            }

            &>i {
                font-size: .44rem;
                vertical-align: middle;
                margin-right: .2rem;
                color: $font-sub-color;
            }

            .language_box {
                position: absolute;
                top: -1rem;
                right: 0;
            }

            &:after {
                content: '';
                width: .17rem;
                height: .17rem;
                border-top: .02rem solid var(--aurora-line);
                border-right: .02rem solid var(--aurora-line);
                position: absolute;
                right: .4rem;
                top: 50%;
                transform: rotate(45deg) translateY(-50%);
            }
        }
    }

    .logout {
        color: $font-sub-color;
        margin: .3rem auto .6rem;
        font-size: .24rem;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
    }
    .vip_box,
    .money_box,
    .contaItem,
    .menus {
        background:
            var(--aurora-soft-gradient);
        border-color: var(--aurora-line);
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .18rem var(--aurora-shadow-color);
    }

    .vip_box .next-vip {
        background: var(--aurora-soft-gradient);
    }

    .vip_box .vip_img .vip_level,
    .vip_box .vip_info .vip_progress:last-child .rate > span {
        color: var(--aurora-accent);
    }

    .money_box .money_wrap > div:last-child,
    .contaItem .spreadLine .spreadName {
        color: var(--aurora-accent);
    }

    .func_btns > div {
        background:
            var(--aurora-soft-gradient);
        color: var(--aurora-ink);
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), inset 0 -.05rem .12rem var(--aurora-shadow-color);
    }

    .func_btns > div:first-child {
        background:
            var(--aurora-soft-gradient);
        color: var(--aurora-ink);
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), inset 0 -.05rem .12rem var(--aurora-shadow-color);
    }

    .func_btns > div:last-child {
        border: 1px solid var(--aurora-line);
    }

    .menus {
        color: var(--aurora-accent);
    }

    .menus .menus-item {
        border-bottom-color: var(--aurora-line);
    }

    .user_info {
        background: var(--aurora-soft-gradient) !important;
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color) !important;

        .icon_logout {
            background:
                var(--aurora-soft-gradient) !important;
            border: 1px solid var(--aurora-line) !important;
            box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .05rem .12rem var(--aurora-shadow-color) !important;
        }
    }

    .vip_box,
    .money_box,
    .contaItem,
    .menus,
    .pages .vip_box,
    .pages .money_box,
    .pages .contaItem,
    .pages .menus {
        background:
            var(--aurora-soft-gradient) !important;
        border-color: var(--aurora-line) !important;
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .18rem var(--aurora-shadow-color) !important;
    }

    .pages .money_box .header,
    .pages .contaItem .contaTitleLine,
    .pages .menus .menus-item,
    .pages .money_box .money_wrap > div:first-child,
    .pages .vip_box .vip_info .vip_progress:last-child .rate {
        color: var(--aurora-ink) !important;
    }

    .pages .money_box .money_wrap > div:last-child,
    .pages .contaItem .spreadLine .spreadName,
    .pages .menus {
        color: var(--aurora-accent) !important;
    }

    .pages .contaItem .line,
    .pages .menus .menus-item {
        border-bottom-color: var(--aurora-line) !important;
    }

    .pages .func_btns > div {
        background:
            var(--aurora-soft-gradient) !important;
        color: var(--aurora-ink) !important;
        border-color: var(--aurora-line) !important;
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), inset 0 -.05rem .12rem var(--aurora-shadow-color) !important;
    }

    .pages .func_btns > div:first-child {
        background:
            var(--aurora-soft-gradient) !important;
        color: var(--aurora-ink) !important;
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), inset 0 -.05rem .12rem var(--aurora-shadow-color) !important;
    }

    .content .pages .func_btns > div,
    .popup .pages .func_btns > div {
        background:
            var(--aurora-soft-gradient) !important;
        color: var(--aurora-ink) !important;
        border: 1px solid var(--aurora-line) !important;
    }

    .content .pages .func_btns > div:first-child,
    .popup .pages .func_btns > div:first-child {
        background:
            var(--aurora-soft-gradient) !important;
        color: var(--aurora-ink) !important;
    }

    &.mobile {
        .user_info .user_box {
            background:
                var(--aurora-soft-gradient) !important;
            border-color: var(--aurora-line) !important;
            box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .18rem var(--aurora-shadow-color) !important;
        }

        .user_info .user_box .icon_logout {
            background:
                var(--aurora-soft-gradient) !important;
            border-color: var(--aurora-line) !important;
            box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .05rem .12rem var(--aurora-shadow-color) !important;
        }

        .user_info .user_box > div .phone,
        .user_info .user_box > div > div,
        .money_box .header,
        .money_box .money_wrap > div:first-child,
        .contaItem .contaTitleLine,
        .menus .menus-item {
            color: var(--aurora-ink) !important;
        }

        .vip_box,
        .money_box,
        .contaItem,
        .menus {
            background:
                var(--aurora-soft-gradient) !important;
            border-color: var(--aurora-line) !important;
            box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .18rem var(--aurora-shadow-color) !important;
        }

        .vip_box .next-vip {
            background: var(--aurora-soft-gradient) !important;
        }

        .vip_box .vip_img .vip_level,
        .vip_box .vip_info .vip_progress .rate span,
        .contaItem .spreadLine .spreadAmount {
            color: var(--aurora-accent) !important;
        }

        .money_box .money_wrap > div:last-child,
        .contaItem .spreadLine .spreadName,
        .menus {
            color: var(--aurora-accent) !important;
        }

        .menus .menus-item,
        .contaItem .line {
            border-bottom-color: var(--aurora-line) !important;
        }
    }

    .content .pages .user_info .user_box .icon_logout,
    .popup .pages .user_info .user_box .icon_logout,
    .content .pages .func_btns > div,
    .popup .pages .func_btns > div {
        background:
            var(--aurora-soft-gradient) !important;
        color: var(--aurora-ink) !important;
        border: 1px solid var(--aurora-line) !important;
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .05rem .12rem var(--aurora-shadow-color) !important;
    }

    .content .pages .func_btns > div:first-child,
    .popup .pages .func_btns > div:first-child {
        background:
            var(--aurora-soft-gradient) !important;
        color: var(--aurora-ink) !important;
        border-color: var(--aurora-line) !important;
    }

    .content .pages .func_btns > div:last-child,
    .popup .pages .func_btns > div:last-child {
        background:
            var(--aurora-soft-gradient) !important;
        color: var(--aurora-ink) !important;
        border: 1px solid var(--aurora-line) !important;
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .05rem .12rem var(--aurora-shadow-color) !important;
    }

    .content .pages .money_box,
    .content .pages .contaItem,
    .content .pages .menus,
    .popup .pages .money_box,
    .popup .pages .contaItem,
    .popup .pages .menus {
        background:
            var(--aurora-soft-gradient) !important;
        border-color: var(--aurora-line) !important;
        box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .18rem var(--aurora-shadow-color) !important;
    }
}</style>
